<p-toast></p-toast>
<div class="grid">
  <div class="col-12">
    <div class="card dashboardTable">
      <p-toolbar styleClass="mb-4" reflow="true">
        <ng-template pTemplate="left" *ngIf="isVendor">
          <button (click)="onVendorFarmer()" pButton pRipple label="{{'ADD_FARMER'| translate}}" icon="pi pi-plus"
            class="p-button-success mr-2"></button>
        </ng-template>
        <ng-template pTemplate="right">
          <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
            class="p-button-help"></button>
          <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
        </ng-template>
      </p-toolbar>

      <p-table  #vendorData [value]="farmerAppDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
          'appID',
          'farmerName',
          'registerationDate',
          'village',
          'block',
          'district',
          'status',
          'remarks',
          'FinYear'
        ]" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
        responsiveLayout="scroll" [loading]="loading">
        <ng-template pTemplate="caption">
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">{{'FARMER_APPLICATION_HEADER'| translate}}</h5>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search"></i>
              <input style="width: 100%;" pInputText type="text" 
              (input)="vendorData.filterGlobal($any($event.target).value, 'contains')"
                 placeholder="{{'SEARCH'| translate}}" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="appID">
              {{'APP_ID'| translate}}
              <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
              <p-sortIcon field="appID"></p-sortIcon>
            </th>
            <th pSortableColumn="farmerName">
              {{'FARMER_NAME'| translate}}
              <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
              <p-sortIcon field="farmerName"></p-sortIcon>
            </th>
            <th pSortableColumn="registerationDate_sort">
              {{'DATE_OF_REG'| translate}}
              <p-columnFilter type="text" field="registerationDate_filter" display="menu"></p-columnFilter>
              <p-sortIcon field="registerationDate_sort"> </p-sortIcon>
            </th>
            <th pSortableColumn="village">
              {{'VILLAGE'| translate}}
              <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
              <p-sortIcon field="village"></p-sortIcon>
            </th>
            <th pSortableColumn="block">
              {{'BLOCK'| translate}}
              <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
              <p-sortIcon field="block"></p-sortIcon>
            </th>
            <th pSortableColumn="district">
              {{'DISTRICT'| translate}}
              <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
              <p-sortIcon field="district"></p-sortIcon>
            </th>
            <th pSortableColumn="status">
              {{'STATUS'| translate}}
              <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
              <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th pSortableColumn="remarks">
              {{'REMARKS'| translate}}
              <p-columnFilter type="text" field="remarks" display="menu"></p-columnFilter>
              <p-sortIcon field="remarks"></p-sortIcon>
            </th>
            <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
              <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
              <p-sortIcon field="FinYear"></p-sortIcon>
            </th>
            <th>{{'VIEW_APPLICATION'| translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-farmerAppDetail>
          <tr>
            <td>{{ farmerAppDetail.appID }}</td>
            <td>{{ farmerAppDetail.farmerName }}</td>
            <td>{{ farmerAppDetail.registerationDate | date }}</td>
            <td>{{ farmerAppDetail.village }}</td>
            <td>{{ farmerAppDetail.block }}</td>
            <td>{{ farmerAppDetail.district }}</td>
            <td>{{ farmerAppDetail.status }}</td>
            <td>{{ farmerAppDetail.remarks }}</td>
            <td>{{ farmerAppDetail.FinYear}}</td>
            <td>
              <!-- <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                class="p-button-rounded p-button-accent mx-1 my-1 btnSize"
                (click)="printForm(farmerAppDetail.appID,far merAppDetail?.vendorCode,farmerAppDetail?.progId)"></button> -->
                <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                class="p-button-rounded p-button-accent mx-1 my-1 btnSize"
                (click)="selectFarmerApplication(farmerAppDetail)"></button>
              <button pButton pRipple pTooltip="edit application" icon="pi pi-pencil" *ngIf="farmerAppDetail.IsEditable == '1'"
                class="p-button-rounded p-button-success mx-1 my-1 btnSize"
                (click)="editForm(farmerAppDetail.appID)"></button>
              <button pButton pRipple pTooltip="delete application" icon="pi pi-trash" *ngIf="farmerAppDetail.IsEditable == '1'"
                class="p-button-rounded p-button-warning mx-1 my-1 btnSize"
                (click)="deleteForm(farmerAppDetail.appID)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">

          </div>
        </ng-template>
      </p-table>

    </div>

    <p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

  </div>
</div>
